{
  "refinement.locale.calendar.unscheduled": "no time set",
  "refinement.locale.calendar.unscheduledDate": "{{date}} · no time set",
  "refinement.locale.calendar.timeRetained": "existing time retained",
  "refinement.locale.calendar.keepTime": "time will be retained",
  "refinement.locale.history.timezone": "Time zone",
  "refinement.locale.history.date": "Date",
  "refinement.locale.history.occurred": "Occurred at",
  "refinement.locale.history.start": "Start",
  "refinement.locale.history.end": "End",
  "refinement.locale.history.channel": "Channel",
  "refinement.locale.history.source": "Source",
  "refinement.locale.validation.required": "{{field}} is required.",
  "refinement.locale.validation.maxLength": "{{field}} must be at most {{maximum}} characters.",
  "refinement.locale.validation.invalidField": "Check the value of this field.",
  "refinement.locale.error.code": "Error code: {{code}}",
  "refinement.locale.filters.active_one": " · {{count}} active",
  "refinement.locale.filters.active_other": " · {{count}} active",
  "refinement.locale.archive.span": "{{kind}} · Layer {{lane}} · {{range}}",
  "refinement.locale.dates.from": "From {{date}}",
  "refinement.locale.dates.until": "Until {{date}}",
  "refinement.locale.dates.ends": "Ends on {{date}}",
  "refinement.locale.routine.cancelled": "cancelled",
  "refinement.locale.routine.pending": "pending",
  "refinement.locale.year.completed_one": "{{count}} completed",
  "refinement.locale.year.completed_other": "{{count}} completed",
  "refinement.locale.year.focus_one": "{{count}} minute of focus",
  "refinement.locale.year.focus_other": "{{count}} minutes of focus",
  "refinement.locale.energy.matches": "matches your energy",
  "refinement.locale.energy.lighter": "below your energy level",
  "refinement.locale.field.defaultUnit": "units",
  "refinement.life.day.actions": "More actions for {{title}}",
  "refinement.life.dock.windows_one": "{{count}} minimized window",
  "refinement.life.dock.windows_other": "{{count}} minimized windows",
  "refinement.locale.task.hidden": "hidden",
  "refinement.locale.date.placeholder": "DD/MM/YYYY",
  "refinement.workdesk.focus.state.closed": "Focus ready",
  "refinement.workdesk.focus.state.open": "Focus open",
  "refinement.workdesk.focus.state.minimized": "Focus minimized",
  "refinement.workdesk.focus.restore": "Return to focus",
  "refinement.locale.time.hourAbbrev": "hr",
  "refinement.locale.count.block_one": "block",
  "refinement.locale.count.block_other": "blocks",
  "refinement.locale.color.indigo": "Indigo",
  "refinement.locale.color.teal": "Teal",
  "refinement.locale.color.amber": "Amber",
  "refinement.locale.color.rose": "Rose",
  "refinement.locale.color.violet": "Violet",
  "refinement.locale.color.emerald": "Emerald",
  "refinement.locale.color.sky": "Sky",
  "refinement.locale.color.clay": "Clay",
  "refinement.locale.color.slate": "Slate",
  "refinement.locale.color.plum": "Plum"
}
